import { type RequirementIdentifier } from '@capsicum/common';
import { atomWithReducer } from 'jotai/utils';

type CustomRequirementsAtom = {
	requirementIndex: number;
	requirements: Array<RequirementIdentifier> | null;
};

type CustomRequirementsAtomAction =
	| { payload: Array<RequirementIdentifier>; type: 'SET' }
	| { payload: number; type: 'SET_INDEX' }
	| { type: 'INCREMENT' }
	| { type: 'RESET' };

const initialState: CustomRequirementsAtom = {
	requirementIndex: 0,
	requirements: null
};

const reducer = (state: CustomRequirementsAtom, action: CustomRequirementsAtomAction): CustomRequirementsAtom => {
	switch (action.type) {
		case 'INCREMENT':
			if (state.requirements === null) return state;

			return {
				...state,
				requirementIndex: state.requirementIndex + 1
			};
		case 'RESET':
			return { requirementIndex: 0, requirements: null };
		case 'SET':
			return { requirementIndex: 0, requirements: action.payload };
		case 'SET_INDEX':
			if (state.requirements === null) return state;

			return {
				...state,
				requirementIndex: action.payload
			};
		default:
			return state;
	}
};

export const customRequirementsAtom = atomWithReducer(initialState, reducer);
